import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VAutocomplete,
    _vm._b(
      {
        attrs: {
          items: _vm.items,
          "item-text": "category_name",
          "item-value": "id",
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (data) {
              return [
                data.item.m0601_id === null
                  ? _c(
                      VListItemContent,
                      { staticClass: "font-weight-bold" },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(data.item.category_name) +
                            "\n    "
                        ),
                      ]
                    )
                  : _c(
                      VListItemContent,
                      { staticClass: "ml-3" },
                      [
                        _c(VListItemTitle, [
                          _vm._v(_vm._s(data.item.category_name)),
                        ]),
                        _vm._v(" "),
                        _c(VListItemSubtitle, [
                          _vm._v(
                            _vm._s(
                              _vm.items.find(
                                (category) => category.id === data.item.m0601_id
                              ).category_name
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.vModel,
          callback: function ($$v) {
            _vm.vModel = $$v
          },
          expression: "vModel",
        },
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }